import { Component, OnInit, AfterViewInit, ViewChild, Renderer, ElementRef, OnDestroy } from "@angular/core";
import { Popup } from 'ionic/ionic';
import { AlertController, App, LoadingController, NavParams, Slides, Platform, ItemReorder, Content } from "ionic-angular";
import { OantutiService } from "../../services/oantuti.services";
import { AppDialog } from "../../component/appDialog";
import { LotteryPage } from "../lottery/lottery";
import { BauCuaHistoryPage } from "../baucuaHistory/baucuaHistory";
import { CommonService } from "../../services/common.service";
import { ScreenOrientation } from "@ionic-native/screen-orientation";
import * as _ from 'lodash';
import { TranslateService } from "ng2-translate";
@Component({
    selector: "oan-tu-ti-page",
    templateUrl: "oantutipage.html"
})

export class OanTuTiPage implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(Content) content: Content;
    @ViewChild(Slides) slides: Slides;
    showAlert = false;
    storeDataReBet = [];
    isMobileWebPortrait = false;
    currentActiveChipInd = 0;
    maxbetValue = 50000000;
    baseValue = 1000000;
    editChipValue = 0;
    storeBalance: any;
    initData: any;
    rebetting = false;
    totalMoneyShow = 0;
    maxGroupChip = 5;
    elem: any;
    ratio = {};
    els: any;
    wApp: number;
    hApp: number;
    gameId: number;
    private objChips = [
        { id: 0, chipVal: "5", status: 1 },
        { id: 1, chipVal: "10", status: 0 },
        { id: 2, chipVal: "25", status: 0 },
        { id: 3, chipVal: "50", status: 0 },
        { id: 4, chipVal: "100", status: 0 },
        { id: 5, chipVal: "200", status: 0 },
        { id: 6, chipVal: "300", status: 0 },
        { id: 7, chipVal: "400", status: 0 },
        { id: 8, chipVal: "500", status: 0 },
        { id: 9, chipVal: "", status: 0, type: 'edit' },
    ];
    listValueChip = ['5', '10', '25', '50', '100', '200', '300', '400', '500'];
    private objCallBackChipSlide: any = {};
    private storeDataBetting: any = [];
    private scrollTop: number = 0;
    private objAudioBackground = new Audio('build/assets/images/oantuti/audio/background.mp3');
    private objAudioOpen = new Audio('build/assets/images/oantuti/audio/open.wav');
    private objAudioPlay = new Audio('build/assets/images/oantuti/audio/play.wav');
    private objAudioClick = new Audio('build/assets/images/oantuti/audio/click.wav');
    private objAudioChip = new Audio('build/assets/images/oantuti/audio/chip.wav');
    public pageDome: HTMLElement;
    private dataTypeBet = new DATA_ITEM_BETTING();
    private isMuted: boolean = false;
    private flagPlayAudioBackground = false;
    constructor(private app: App, public params: NavParams,
         private ottService: OantutiService, private el: ElementRef, private alertCtrl: AlertController, public loadingCtrl: LoadingController, private common: CommonService, public platform: Platform, private screenOrientation: ScreenOrientation, private translate: TranslateService) {
        this.pageDome = el.nativeElement;
        this.gameId = params['data'].lotteryId;
        platform.ready().then(() => {
            this.wApp = platform.width();
            this.hApp = platform.height();
            if (platform.is('mobileweb') && !platform.isLandscape()) {
                this.isMobileWebPortrait = true;
            }
            if (!platform.is('mobileweb') && (platform.is('android') || platform.is('ios') || platform.is('windows'))) {
                this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
            }
        });

        this.screenOrientation.onChange().subscribe(
            () => {
                if (platform.is('mobileweb')) {
                    this.isMobileWebPortrait = !this.isMobileWebPortrait;
                }
            }
        );

        this.pageDome.addEventListener('click', (event) => {
            if (this.flagPlayAudioBackground) return false;
            this.flagPlayAudioBackground = true;
            this.objAudioBackground.play();
            this.objAudioBackground.volume = 0.15;
            this.objAudioBackground.loop = true;
        });
    }
    ngOnInit() {
        this.elem = document.documentElement;
        this.els = {
            elsUserHandLeft: document.getElementById('hand-left'),
            elsUserHandRight: document.getElementById('hand-right'),
            elsFigureLeft: document.querySelector('.figure-left'),
            elsFigureRight: document.querySelector('.figure-right'),
            elsFigureBetLeft: document.querySelector('.figure-bet-left'),
            elsFigureBetRight: document.querySelector('.figure-bet-right'),
            elsBalance: document.querySelector('.balance--amount'),
            elsChipSlide: document.querySelector('.chipsSlide')
        };
        this.content.ionScroll.subscribe((data) => {
            this.scrollTop = data.scrollTop;
        });
        this.randomFigure();
        this.apiInitOantuti();
        this.apiGetBalance();
    }

    ngAfterViewInit() {
        this.slides.ionSlideTransitionEnd.subscribe(() => this.slideTransitionEnd());
    }


    ngOnDestroy() {
        if (!this.isMuted) {
            this.objAudioBackground.pause();
        }
    }

    toggleSound() {
        this.isMuted = !this.isMuted;
        if (!this.isMuted) {
            this.objAudioBackground.play();
        } else {
            this.objAudioBackground.pause();
        }
    }
    playAudioClick() {
        if (!this.isMuted) {
            this.objAudioClick.play();
        }
    }
    playAudioChip() {
        if (!this.isMuted) {
            this.objAudioChip.play();
        }
    }
    playAudioOpen() {
        if (!this.isMuted) {
            this.objAudioOpen.play();
        }
    }
    playAudioPlay() {
        if (!this.isMuted) {
            this.objAudioPlay.play();
        }
    }
    apiInitOantuti() {
        this.ottService.init1s([], this).then(data => {
            if (data['msg'] === '') {
                this.initData = data['model'];
                this.ratio = [];
                _.each(data['model'], item => {
                    const ratio = Number((item.level1 - item.levelnum).toFixed(2));
                    this.ratio[item.checkflag] = `${item.levelnum} : ${ratio}`;
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: 'Lỗi kết nối!'
                });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    apiGetBalance(funCallBack?: any) {
        this.ottService.getBalanceMain([], null).then(data => {
            if (data['msg'] === '') {
                this.storeBalance = this.common.numberWithCommas(data['balance']);
                funCallBack && funCallBack();
            } else {
                this.storeBalance = "0";
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: 'Lỗi kết nối!'
                });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    submitBettingOantuti(params) {
        this.ottService.bettingOantuti(params, null)
            .then(data => {
                if (data['msg'] === '') {
                    this.storeDataReBet = this.storeDataBetting;
                    const getResult = JSON.parse(data['betresult']);
                    if (getResult['success'] === 1) { // is success
                        const timeoutEffectMoneyLoss = 100;
                        const dataResult = getResult['data'];
                        this.showResult(dataResult['result']);
                        setTimeout(() => {
                            this.effectOpenWin(dataResult);
                        }, timeoutEffectMoneyLoss + 20);
                    } else {
                        AppDialog.alert({
                            alertCtrl: this.alertCtrl,
                            message: data['msg']
                        });
                    }
                } else {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: 'Lỗi kết nối!'
                    });
                }
            })
            .catch(error => {
                console.log(error);
            })
    }

    showResult(data) {
        this.playAudioOpen();
        const resultClass = data.split('|');
        this.els.elsUserHandRight.removeAttribute('style');
        this.els.elsUserHandLeft.removeAttribute('style');

        //start simulator result
        this.els.elsUserHandRight.classList.remove('hand-start-right');
        this.els.elsUserHandRight.classList.add(`hand-result-right-${resultClass[1]}`);
        this.els.elsUserHandLeft.classList.remove('hand-start-left');
        this.els.elsUserHandLeft.classList.add(`hand-result-left-${resultClass[0]}`)
        //end simulator result
        this.rebetting = false;
        this.storeDataReBet = this.storeDataBetting;
    }

    effectOpenWin(dataResult) {
        const result = dataResult['result'].split('|');
        this.storeBalance = this.common.numberWithCommas(dataResult['balance']);
        result.forEach(typeBetKey => {
            const elTypeBet = this.pageDome.querySelector(`.typebet-${typeBetKey}`);
            elTypeBet.classList.add('effectOpenWin');
            setTimeout(() => {
                this.chipMoveWin(typeBetKey);
            }, 200);
        });
        setTimeout(() => {
            const elsTypeBet = this.pageDome.querySelectorAll('[data-bet]');
            this.removeClassesAllEls(elsTypeBet, 'effectOpenWin');
            if (Number(dataResult['prize']) > 0) {
                this.pageDome.querySelector('.moneyStatusBet').innerHTML = `+${this.numberWithCommas(dataResult['prize'])}`;
                this.pageDome.querySelector('#effectMoneyBet').classList.add('winMoney', 'showMoneyEffectBet');
                this.chipMoveLose();
                const timeoutEffectMoneyWin = 1500;
                setTimeout(() => {
                    this.pageDome.querySelector('#effectMoneyBet').classList.remove('lossMoney', 'winMoney', 'showMoneyEffectBet');
                }, timeoutEffectMoneyWin + 20);
            } else {
                this.chipMoveLose();
                this.pageDome.querySelector('#effectMoneyBet').classList.remove('lossMoney', 'showMoneyEffectBet');
            }
            this.clearBet(false);
            const elNumEffect = this.pageDome.querySelector('.effectNumWinMore');
            if (elNumEffect) elNumEffect.remove();
        }, 1500);
    }

    chipMoveWin(typebet) {
        let chipMove = document.querySelectorAll(`.chip-${typebet}`);
        const getPosiTypeBet = this.getPositionXYEl(this.els.elsBalance);
        _.each(chipMove, chip => {
            const getPosiCurrentChipActive = this.getPositionXYEl(chip);
            let topChipMove = getPosiTypeBet.y + getPosiTypeBet.h - getPosiCurrentChipActive.h;
            let leftChipMove = getPosiTypeBet.x + getPosiTypeBet.w / 2 - getPosiCurrentChipActive.w / 2 - 10;
            chip.style.left = leftChipMove + 'px';
            chip.style.top = topChipMove + 'px';
        })
        setTimeout(() => {
            this.removeAllEls(chipMove);
        }, 500);
    }

    chipMoveLose() {
        const wrapper = this.pageDome.querySelector('#wrapper');
        const elsChipEmbed = wrapper.querySelectorAll('.chipEmbed');
        const getPosiTypeBet = this.getPositionXYEl(this.els.elsChipSlide);
        _.each(elsChipEmbed, chip => {
            const getPosiCurrentChipActive = this.getPositionXYEl(chip);
            let topChipMove = getPosiTypeBet.y + getPosiTypeBet.h - getPosiCurrentChipActive.h;
            let leftChipMove = getPosiTypeBet.x + getPosiTypeBet.w / 2 - getPosiCurrentChipActive.w / 2 - 10;
            chip.style.left = leftChipMove + 'px';
            chip.style.top = topChipMove + 'px';
        })
        setTimeout(() => {
            this.removeAllEls(elsChipEmbed);
        }, 500);
    }

    randomFigure = function () {
        const randGirl = Math.floor(Math.random() * 6) + 1;
        const randBoy = Math.floor(Math.random() * 9) + 1;
        const getClsGirl = `figure-girl-${randGirl}`;``
        const getClsBoy = `figure-boy-${randBoy}`;
        this.els.elsFigureLeft.classList.add(getClsGirl);
        this.els.elsFigureBetLeft.classList.add(getClsGirl);
        this.els.elsFigureRight.classList.add(getClsBoy);
        this.els.elsFigureBetRight.classList.add(getClsBoy);
    };

    dismissPage() {
        this.platform.ready().then(() => {
            if( !this.platform.is('mobileweb') && (this.platform.is('android') || this.platform.is('ios') || this.platform.is('windows'))) {
                this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
            }
        });
        let tabsRoot = this.app.getRootNav();
        tabsRoot.pop();
    }

    guideGame() {
        this.playAudioClick();
        let title = "Hướng dẫn chơi";
        let alertCmp = this.alertCtrl.create({
            title: title,
            cssClass: 'guideGame',
            message:
                `<div id="oantutiInfor" class="instruction-dialog" style="display:none;">
                    <div class="inner">
                        <div class="content">
                            <table>
                                <tr>
                                    <th>${this.translate.instant('HELP_GAME')}</th>
                                    <th>${this.translate.instant('OANTUTI_PAGE.EXPLAIN')}</th>
                                    <th>${this.translate.instant('OANTUTI_PAGE.EXAMPLE')}</th>
                                </tr>
                                <tr>
                                    <td><img src="build/assets/images/oantuti/oantuti.png" alt=""></td>
                                    <td colspan="2">
                                        <ul>
                                            <li>1. Luật chơi game oẳn tù tì tương tự luật chơi trong dân gian, nghĩa là <b class="red">Búa thắng Kéo,
                                                Kéo thắng Bao và Bao thắng Búa</b></li>
                                            <li>2. Máy sẽ chọn ngẫu nhiên hình đại diện cho 2 bên Trái và Phải.<br>
                                                Để bắt đầu lượt chơi, người chơi sẽ chọn đặt chip vào các cửa cược bên Trái hoặc bên Phải (có tất cả 9 cửa cược)</li>
                                            <li>3. Sau khi xác nhận cược thành công, người chơi nhấn vào nút Tù Tì, hệ thống sẽ hiển thị
                                                kết quả và tính thưởng</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td><img src="build/assets/images/oantuti/left-win.png" alt=""></td>
                                    <td>Cược bên Trái thắng</td>
                                    <td>
                                        <p>VD: bên Trái ra Búa, bên Phải ra Kéo</p>Nếu cược Trái THẮNG, người chơi sẽ thắng
                                    </td>
                                </tr>
                                <tr>
                                    <td><img src="build/assets/images/oantuti/hoa.png" alt=""></td>
                                    <td>Cược Trái và Phải hòa</td>
                                    <td>
                                        <p>VD: Trái ra Búa, Phải cũng ra Búa</p>Nếu cược HÒA, người chơi sẽ thắng
                                    </td>
                                </tr>
                                <tr>
                                    <td><img src="build/assets/images/oantuti/right-win.png" alt=""></td>
                                    <td>Cược Phải thắng</td>
                                    <td>
                                        <p>VD: Trái ra Búa, Phải ra Bao</p>Nếu cược Phải THẮNG, người chơi sẽ thắng
                                    </td>
                                </tr>
                                <tr>
                                    <td><img src="build/assets/images/oantuti/keo-l.png" alt=""></td>
                                    <td>Cược Trái hoặc Phải ra Kéo</td>
                                    <td>
                                        <p>VD: Trái ra Kéo, Phải ra Búa</p>Nếu cược vào cửa Trái ra KÉO, người chơi sẽ thắng
                                    </td>
                                </tr>
                                <tr>
                                    <td><img src="build/assets/images/oantuti/bua-l.png" alt=""></td>
                                    <td>Cược Trái hoặc Phải ra Búa</td>
                                    <td>
                                        <p>VD: Trái ra Búa, Phải ra Búa</p>Nếu cược vào cửa Trái ra BÚA, người chơi sẽ thắng
                                    </td>
                                </tr>
                                <tr>
                                    <td><img src="build/assets/images/oantuti/la-l.png" alt=""></td>
                                    <td>Cược Trái hoặc Phải ra Bao</td>
                                    <td>
                                        <p>VD: Trái ra Bao, Phải ra Kéo</p>Nếu cược vào cửa Trái ra BAO, người chơi sẽ thắng
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>`,
            buttons: [
                {
                    text: ''
                }
            ]
        });
        alertCmp.present();
    }

    chipSelect(chipVal, ind) {
        if (chipVal === '') {
            this.editChip(null);
            return;
        }
        this.playAudioClick();
        // start update status chip
        this.currentActiveChipInd = ind;
        _.each(this.objChips, chip => {
            chip['status'] = 0;
        });
        this.objChips[ind]['status'] = 1;
        // end update status chip
    }

    removeClassesAllEls(els, cls) {
        for (let i = 0; i < els.length; i++) {
            els[i].classList.remove(cls);
        }
    }

    selectTypeBet(className) {
        let countCurShowChip = this.slides.getActiveIndex() + 5;
        if (countCurShowChip <= this.currentActiveChipInd || countCurShowChip - this.currentActiveChipInd > 5) { // slide to up
            this.slides.slideTo(this.currentActiveChipInd);
            this.objCallBackChipSlide = { chipVal: this.objChips[this.currentActiveChipInd].chipVal, typeBet: className };
        } else { // slide normal
            this.objCallBackChipSlide = {};
            this.addChip(this.objChips[this.currentActiveChipInd].chipVal, className);
        }
    }

    slideTransitionEnd() {
        if (!this.isEmptyObject(this.objCallBackChipSlide)) {
            this.addChip(this.objCallBackChipSlide.chipVal, this.objCallBackChipSlide.typeBet);
            this.objCallBackChipSlide = {};
        }
    }

    addChip(chipVal, typeBet) {
        let valueChip = 0;
        if (_.includes(chipVal, 'M')) {
            valueChip = Number(chipVal.replace('M', '.')) * 1000;
        } else {
            valueChip = Number(chipVal);
        }
        const currentBetItem = this.storeDataBetting.find(itemMaxBet => itemMaxBet['itemBetting'] === typeBet);
        const typebetModel = this.initData.find(model => model['checkflag'] === typeBet);
        if (currentBetItem && (currentBetItem.totalMoney + Number(valueChip)) * 1000 > typebetModel.maxbet || valueChip * 1000 > typebetModel.maxbet) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: `Vượt mức giới hạn cược ${this.numberWithCommas(typebetModel.maxbet)}`
            });
            return;
        }
        if ((this.totalMoneyShow + Number(valueChip) * 1000) > Number(this.storeBalance.replace(/[,]/g, ''))) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: `Số dư không đủ.`
            });
            return
        }
        const wrapper = this.pageDome.querySelector('#wrapper');
        const elTypeBet = this.pageDome.querySelector(`.typebet-${typeBet}`);
        const getPosiTypeBet = this.getPositionXYEl(elTypeBet);
        const elChipActive = this.pageDome.querySelector(`[data-chip="${chipVal}"]`);
        const chip = document.createElement('span');
        const getPosiCurrentChipActive = this.getPositionXYEl(elChipActive);
        let elChipEmbed = wrapper.querySelectorAll(`.chip-${typeBet}`);
        let elChipLast = undefined;
        let zIndexChip = "1";
        if (elChipEmbed.length > 0) {
            elChipLast = elChipEmbed[elChipEmbed.length - 1];
            zIndexChip = (Number(elChipLast.style.zIndex) + 1).toString();
        }
        chip.style.zIndex = zIndexChip;
        chip.classList.add('chip', 'chipEmbed', `chip-${typeBet}`);
        // chip.style.top = getPosiCurrentChipActive.y + 'px';
        // chip.style.left = getPosiCurrentChipActive.x + 'px';
        chip.style.top = (elChipActive.getBoundingClientRect().top - elChipActive.getBoundingClientRect().height + this.scrollTop) + 'px';
        chip.style.left = elChipActive.getBoundingClientRect().left + 'px';
        chip.setAttribute('data-chipval', chipVal);
        let isEditedChip = this.objChips[this.currentActiveChipInd]['type'] === 'edit';
        if (isEditedChip) {
            chip.innerHTML = `<span class="iconBauCua item edited"></span><span class="numchip">${chipVal}</span>`;
        } else {
            chip.innerHTML = `<span class="iconBauCua item chip-${chipVal}"></span><span class="numchip">${chipVal}</span>`;
        }
        wrapper.appendChild(chip);

        // start move effect chip
        setTimeout(() => {
            let topChipMove = (elTypeBet.getBoundingClientRect().top - elTypeBet.getBoundingClientRect().height/2 + this.scrollTop);
            let leftChipMove = 0;
            if (getPosiTypeBet.x > this.wApp / 2) {
                leftChipMove = elTypeBet.getBoundingClientRect().left
                    + (elTypeBet.getBoundingClientRect().width / 2)
                    - (getPosiCurrentChipActive.w / 2) - 15;
            } else {
                leftChipMove = elTypeBet.getBoundingClientRect().left
                    + (elTypeBet.getBoundingClientRect().width / 2)
                    - (getPosiCurrentChipActive.w / 2) + 25;
            }
            chip.style.left = leftChipMove + 'px';
            if (elChipEmbed.length >= this.maxGroupChip) { // group chip and calculate position top for chip next hidden
                topChipMove = elChipLast.style.top.replace('px', '');
                chip.classList.add('chipEmbedHideGroup');
                this.updateMoneyGroupChips(typeBet);
            } else if (elChipLast) { // position top for chip next
                topChipMove = Number(elChipLast.closest('.chipEmbed').style.top.replace('px', '')) - 5;
            }
            chip.style.top = topChipMove + 'px';

            // start store chip position move
            const objStoreChipPosiMove = {
                chipVal: valueChip,
                indexChip: this.getIndexChip(chipVal),
                leftChipMove: leftChipMove,
                topChipMove: Number(topChipMove),
                zIndex: zIndexChip
            };
            // end store chip position move
            this.dataStoreBetting(typeBet, objStoreChipPosiMove);
            this.playAudioChip();
        }, 100);
        // end move effect chip

    }

    getIndexChip(value) {
        return _.find(this.objChips, item => {
            return item.chipVal === value;
        }).id;
    }

    numberWithCommas(x) {
        const num = Number(x).toFixed(0);
        return num.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    getPositionXYEl(el) {
        const elIonContent = this.pageDome.querySelector('ion-content.content');
        const getBoundingIonContent = elIonContent.getBoundingClientRect();
        const elScrollContent = this.pageDome.querySelector('.scroll-content');
        const getElScrollContentTop = Number(elScrollContent['style'].marginTop.replace(/px/g, ''));
        let getRectEl = el.getBoundingClientRect();
        return { x: getRectEl.left, y: getRectEl.top - getElScrollContentTop - getBoundingIonContent['top'], w: getRectEl.width, h: getRectEl.height };
    }

    updateMoneyGroupChips(typeBet) {
        const wrapper = this.pageDome.querySelector('#wrapper');
        const elChipEmbed = wrapper.querySelectorAll(`.chip-${typeBet}`);
        const elChipShowMoney = elChipEmbed[this.maxGroupChip - 1];
        elChipShowMoney.querySelector('.numchip').innerHTML = this.typeBetChipsVal(typeBet).toString();
    }

    typeBetChipsVal(typeBet) {
        const wrapper = this.pageDome.querySelector('#wrapper');
        const elChipEmbed = wrapper.querySelectorAll(`.chip-${typeBet}`);
        let totalMoney = 0;
        let chipVal;
        for (let i = 0; i < elChipEmbed.length; i++) {
            const item = elChipEmbed[i];
            let getChipVal = item['dataset'].chipval;
            if (_.includes(getChipVal, 'M')) {
                getChipVal = Number(getChipVal.replace('M', '.')) * 1000;
            }
            totalMoney += Number(getChipVal);
            if (totalMoney > 1000) {
                let valueArr = (totalMoney / 1000).toString().split('.');
                chipVal = `${valueArr[0]}M`;
                if (valueArr[1]) {
                    chipVal = `${chipVal}${valueArr[1]}`
                }
            } else {
                chipVal = totalMoney;
            }
        }
        return chipVal;
    }

    dataStoreBetting(typeBetChoose, objStoreChipPosiMove) {
        if (this.storeDataBetting.length <= 0) { // constructor store data betting
            this.dataTypeBet.itemBetting = typeBetChoose;
            this.dataTypeBet.totalMoney += Number(objStoreChipPosiMove.chipVal);
            this.dataTypeBet.chips.push(objStoreChipPosiMove);
            this.storeDataBetting.push(this.dataTypeBet);
        } else { // update data betting
            let countCheckExist = 0;
            this.storeDataBetting = this.storeDataBetting.map((item, idx) => {
                if (item['itemBetting'] === typeBetChoose) { // exist
                    const getMaxBetTypeBet = this.initData.find(itemMaxBet => itemMaxBet['checkflag'] === item['itemBetting']);
                    if (item['totalMoney'] <= getMaxBetTypeBet['maxbet']) {
                        item['totalMoney'] += Number(objStoreChipPosiMove.chipVal);
                        item.chips.push(objStoreChipPosiMove);
                    }
                } else { // not exist
                    countCheckExist += 1;
                }
                return item;
            });

            // constructor store new data betting
            if (countCheckExist === this.storeDataBetting.length) {
                this.dataTypeBet = new DATA_ITEM_BETTING();
                this.dataTypeBet.itemBetting = typeBetChoose;
                this.dataTypeBet.totalMoney += Number(objStoreChipPosiMove.chipVal);
                this.dataTypeBet.chips.push(objStoreChipPosiMove);
                this.storeDataBetting.push(this.dataTypeBet);
            }
        }
        this.totalMoneyShow = this.storeDataBetting.reduce((accumulator, currentValue) => { return accumulator + currentValue['totalMoney']; }, 0) * 1000;
    }

    preventTimeoutRemove() {
        this.pageDome.querySelector('.bgoverlay').remove();
    }

    isEmptyObject(obj) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    editChip(event) {
        if (event) {
            event.stopPropagation();
        }
        let title = "Nhập giá trị chip";
        let $scope = this;
        let alertCmp = this.alertCtrl.create({
            title: title,
            inputs: [
                {
                    name: 'value',
                    placeholder: 'chip value',
                    type: 'string',
                    id: 'input-chip'
                }
            ],
            cssClass: 'wrap-custom-chip',
            buttons: [
                {
                    text: 'Cập nhật',
                    handler: function (data) {
                        if (data.value !== "") {
                            $scope.addNewChip(data.value);
                        }

                    }
                }
            ]
        });
        alertCmp.present();
        setTimeout(() => {
            let _self = this;
            document.querySelector('.alert-wrapper input').addEventListener('keyup', function (e) {
                // e.preventDefault();
                const valIput = e.target['value'].replace(/[,]/g, '');
                e.target['value'] = _self.common.numberWithCommas(Number(valIput));
            });
        }, 100);
    }

    addNewChip(value) {
        value = Number(value.replace(/[,]/g, ''));
        if (value < 1000) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: `Giá trị chip tối thiểu là 1000 .`
            });
            return
        } else if (_.includes(this.listValueChip, (Number(value) / 1000).toString())) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: `Chip đã tồn tại.`
            });
        } else if (value > this.maxbetValue) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: `Giá trị chip tối đa là 50,000,000 `
            });
        } else if ((value / this.baseValue).toString().split('.').length > 1 && (value / this.baseValue).toString().split('.')[1].length > 1) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: `
                    Giá trị chip phải là bội số của 100,000 .
                    VD: 700,000 hoặc 6,200,000 hoặc 10,500,000
                `
            });
        } else {
            let valueArr = (value / this.baseValue).toString().split('.');
            let chipVal = '';
            if (value >= this.baseValue) {
                chipVal = `${valueArr[0]}M`;
                if (valueArr[1]) {
                    chipVal = `${chipVal}${valueArr[1]}`
                }
            } else {
                chipVal = (value / 1000).toString();
            }
            this.objChips[this.objChips.length - 1].chipVal = chipVal;
        }
    }

    oantuti(event) {
        this.playAudioPlay();
        event.preventDefault();
        if (this.storeDataBetting.length <= 0) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Vui lòng đặt cược!'
            });
            return false;
        }
        //start reset class element for start
        this.els.elsUserHandRight.classList.remove('hand-result-right-rock_right', 'hand-result-right-sciss_right', 'hand-result-right-paper_right');
        this.els.elsUserHandRight.classList.add('hand-start-right');
        this.els.elsUserHandLeft.classList.remove('hand-result-left-rock_left', 'hand-result-left-sciss_left', 'hand-result-left-paper_left');
        this.els.elsUserHandLeft.classList.add('hand-start-left');
        //end reset class element for start

        const timeEffectPlay = 350;
        const countPlay = 3;
        const cssHandRight = `transform-origin: right;animation: rotarHandRight ${timeEffectPlay}ms infinite;animation-iteration-count: ${countPlay};`;
        this.els.elsUserHandRight.setAttribute('style', cssHandRight);
        const cssHandLeft = `transform-origin: left;animation: rotarHandLeft ${timeEffectPlay}ms infinite;animation-iteration-count: ${countPlay};`;
        this.els.elsUserHandLeft.setAttribute('style', cssHandLeft);
        const paramsBetting = new DATA_SUBMIT_BETTING();
        paramsBetting.money = this.totalMoneyShow;
        _.each(this.storeDataBetting, item => {
            paramsBetting[`betdata[${item.itemBetting}]`] = Number(item.totalMoney) * 1000;
        });
        this.pageDome.querySelector('.moneyStatusBet').innerHTML = `-${this.numberWithCommas(paramsBetting.money)}`;
        this.pageDome.querySelector('#effectMoneyBet').classList.add('lossMoney', 'showMoneyEffectBet');
        setTimeout(() => {
            this.submitBettingOantuti(paramsBetting);
        }, 1000);
    };
    clearBet(removeChip) {
        this.playAudioClick();
        if (removeChip) {
            const wrapper = this.pageDome.querySelector('#wrapper');
            const elsChipEmbed = wrapper.querySelectorAll('.chipEmbed');
            this.removeAllEls(elsChipEmbed);
        }
        this.storeDataBetting = [];
        this.totalMoneyShow = 0;
        this.dataTypeBet = new DATA_ITEM_BETTING();
        this.rebetting = false;
    }
    removeAllEls(els) {
        for (let i = 0; i < els.length; i++) {
            els[i].remove();
        }
    }

    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    findActiveChipId(chip) {
        return this.objChips.find(item => {
            return (item.id).toString() === (chip.indexChip).toString();
        }).id;
    }

    reBet() {
        this.playAudioClick();
        if (this.storeDataReBet.length <= 0) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: this.translate.instant('NO_PREVIOUS_BET')
            });
            return false;
        }
        if (!this.rebetting) {
            this.rebetting = true;
            this.clearBet(true);
            setTimeout(() => {
                this.storeDataReBet.forEach(item => {
                    item.chips.forEach(chip => {
                        // this.currentActiveChipInd = this.findActiveChipId(chip);
                        this.chipSelect(chip.chipVal, this.findActiveChipId(chip));
                        this.selectTypeBet(item.itemBetting);
                    });
                });
            }, 100);
        }
    }

    viewHistoryOantuti() {
        this.playAudioClick();
        this.app.getRootNav().push(BauCuaHistoryPage, {
            gameID: this.gameId
        });
    }
    ionViewWillLeave() {
        this.platform.ready().then(() => {
            if( !this.platform.is('mobileweb') && (this.platform.is('android') || this.platform.is('ios') || this.platform.is('windows'))) {
                this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
            }
        });
    }
}

function DATA_SUBMIT_BETTING() {
    this.flag = 'Bet';
    this.gameid = 94;
    this.money = 0;
}

function DATA_ITEM_BETTING() {
    this.totalMoney = 0;
    this.itemBetting = '';
    this.chips = [];
}


// WEBPACK FOOTER //
// ./src/pages/oantuti/oantutipage.ts